export const MaxLengths = {
  SELLER_REFERENCE: 255,
  SELLER_PRICE: 255,
  ORIGINAL_URL: 1000,
  TITLE: 255,
  FREE_FIELD_VALUE: 255,
  RESELLER_PRICE: 255,
};
